export const HOSTFULLY_ASSIST_PATH = '/hostfully-assist';

export const HOSTFULLY_ASSIST_DETAILS_PATH = `${HOSTFULLY_ASSIST_PATH}/details`;
